<template>
  <div>
    <div class="opc-plan__bought-license" v-if="displayCount">
      <span>{{ $t('billing.prorated.cur_users', [displayCount, unit]) }}</span>
      <span v-if="showExtraInfo"> {{ this.extraInfo }} </span>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { getPlanUnitWithQuantity } from '@/common/product-unit';
import mx from './mx.vue';
export default {
  props: {
    value: Number,
    showExtraInfo: {
      type: Boolean,
      default: false,
    },
    customUnit: String,
    extraInfo: String,
  },
  mixins: [mx],
  computed: {
    displayCount() {
      if (this.mx_boughtPlan.category !== this.mx_cartPlan.category) return "";
      return `${this.mx_boughtPlan.cartInfo?.selected_number ?? ''}`;
    },
    unit() {
      return this.customUnit || getPlanUnitWithQuantity(this.mx_boughtPlan?.unit);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils.scss';

.opc-plan__bought-license {
  font-family: Almaden Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  padding: 8px 0;
  text-align: left;
  color: #666487;
  @include simplifyStyle() {
    padding: 0;
  }
}
</style>
